export default __webpack_public_path__ + "static/media/Icon.c370ff16.png";